<template>
  <article class="home-form">
    <div class="home-form__content">
      <fieldset class="home-form__fieldset">
        <input type="text" placeholder="Name" class="input" />
        <input type="email" placeholder="Email" class="input" />
      </fieldset>

      <fieldset class="home-form__fieldset">
        <input type="email" placeholder="Company" class="input" />
        <input type="email" placeholder="Phone number" class="input" />
      </fieldset>

      <fieldset class="home-form__fieldset">
        <div class="input">
          <select name="cars" class="input__select" required>
            <option value="" disabled selected>{{ $t('common.form.subject') }}</option>
            <option value="contact">{{ $t('common.form.getTouch') }}</option>
            <option value="partner">{{ $t('common.form.partner') }}</option>
          </select>
        </div>

        <div class="input">
          <select name="cars" class="input__select" required>
            <option value="" disabled selected>{{ $t('common.languages.title') }}</option>
            <option value="contact">{{ $t('common.languages.english') }}</option>
            <option value="partner">{{ $t('common.languages.french') }}</option>
            <option value="partner">{{ $t('common.languages.spanish') }}</option>
          </select>
        </div>
      </fieldset>

      <fieldset class="home-form__fieldset">
        <textarea placeholder="Message*" class="input -textarea" />
      </fieldset>

      <ActionButton>{{ $t('common.form.button') }}</ActionButton>
    </div>

    <iframe :src="`/contact-form-${$i18n.locale}.html`" frameborder="0" class="home-form__frame" />
  </article>
</template>

<script>
export default {
  name: 'HomeContactForm'
}
</script>
